export default {
  // Moduri
  "common.mode.auto": "Autoconsum",
  "common.mode.economy": "Mod economic",
  "common.mode.exigency": "Mod de urgență",

  // Dispozitive
  "common.grid": "Rețea electrică",
  'common.evChargers': 'Stații de încărcare',
  'common.evCharger': 'Stație de încărcare',
  'common.pv': 'Solar',
  'common.inverter': 'Invertor',
  'common.pcs': 'Invertor + Baterie',
  'common.terminal': 'Dispozitiv terminal',
  'common.airc': 'Aer condiționat',
  'common.engine': 'Motor',
  'common.battery': 'Baterie',
  'common.metter': 'Contor electric',
  'common.other': 'Altele',
  "common.power": "Putere",
  "common.powerTotal": "Putere totală",
  "common.voltage": "Tensiune",
  "common.electricity": "Energie electrică",
  "common.current": "Curent",
  "common.homeUsage": "Sarcină totală casnică",
  "common.battery.power": "Putere baterie",

  // Date
  "common.noDataAvailable": 'Nu sunt date disponibile momentan~',
  'common.tips': 'Sfat',
  "common.reset": "Resetează",
  "common.currencyUnit": '¥',
  "common.submiting": 'Se trimite, vă rugăm așteptați...',
  "common.close": 'Închide',
  "common.from": 'De la',
  "common.useIn": 'Folosit în',
  "common.energyPercent": 'Procent flux energetic',
  "common.dataFlow": "Flux de date",
  "common.getDataIng": 'Se preiau date, vă rugăm așteptați...',
  "common.pageLoading": 'Se încarcă pagina, vă rugăm așteptați...',
  "common.reseting": "Conținutul paginii se resetează, vă rugăm așteptați...",
  "common.save": 'Salvează',
  "common.onlyNumberTips": "Se pot introduce doar numere",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault":"Defect",
  "common.charge": "Încărcare",
  "common.discharge": "Descărcare",
  "common.buy": "Cumpărare",
  "common.sell": "Vânzare",
  "common.loadingInfo": 'Se încarcă, vă rugăm așteptați...',

  // 
  "common.moreFeatures": "Mai multe funcții",
  "common.confirm": 'Confirmă',
  "common.saveing": "Se salvează, vă rugăm așteptați...",
  "common.searchPlacholder": "Introduceți cuvânt cheie de căutare",
  "common.iSee": 'Am înțeles',
  "common.pageErrorTips1": "Ups, pagină cu eroare~",
  "common.pageErrorTips2": "Încercați să reîmprospătați pagina sau contactați serviciul clienți~",
  "common.refresh": "Reîmprospătează",
  "common.backToHome": "Înapoi la pagina principală",
  "common.checkTips": "Se verifică, vă rugăm așteptați...",
  "common.back": "Înapoi",
  "common.cancel": "Anulează",
  "common.optional": "Opțional",
  "common.required": "Obligatoriu",
  "common.status": "Stare",
  "common.statusNoDelete": "Neșters",
  "common.statusDelete": "Șters",
  "common.submit": 'Trimite',
  "common.disable": "Dezactivează",
  "common.enable": "Activează",
  "common.year": 'an',
  "common.month": 'lună',
  "common.day": 'zi',
  "common.version": 'Număr versiune:',
  "common.backHome": ' Înapoi la pagina principală',
  "common.backHomeSorry": ' Ne pare rău, pagina s-a rătăcit',
  "common.requestTips1": 'Datele se procesează, nu retrimiteți',
  "common.requestTips2": "Mesaj sistem",
  "common.requestTips3": "Starea de conectare a expirat, reconectați-vă",
  "common.requestTips4": "Reconectare",
  "common.requestTips5": "Sesiune invalidă, sau sesiunea a expirat, reconectați-vă",
  "common.requestTips6": "Eroare server, vă rugăm să încercați din nou mai târziu.",
  "common.requestTips7": "Timp depășit pentru cererea interfeței sistem",
  "common.requestTips8": 'Interfață sistem',
  "common.requestTips9": 'Eroare',
  "common.iknow": 'Am înțeles',
  "common.logoutSuccess": "Deconectare reușită",
  
  // Componentă Află mai multe
  "common.knowMore.title": 'Pentru mai multe informații, contactați BeiNeng',
  "common.knowMore.email": 'Email',
  "common.knowMore.phone": 'Telefon',
  "common.knowMore.wechat": 'WeChat',
  "common.knowMore.website": 'Site web',
  "common.knowMore.address": 'Adresă',
  "common.knowMore.addressDetail": 'Camerele 1205 și 1301, Clădirea 5, Nr. 8 Qinghe Road, Huangjingkeng, Orașul Huangjiang, Dongguan, Provincia Guangdong',
  
  // Componentă conexiune locală
  "common.localConnection": 'Conexiune locală',
  "common.operateInApp": 'Vă rugăm să operați în aplicație!',
  
  "common.enbleStaus": "Stare activare",
  "common.battery.status": "Nu se încarcă și nici nu se descarcă",

  'account.forgetThePassword': 'Am uitat parola',
    'account.logInDirectly': 'Mergi direct la conectare',
    'account.tips1': 'Redirecționare, vă rugăm așteptați...',
    'account.tips2': 'Vă rugăm să citiți și să acceptați termenii de utilizare mai întâi!',
    'account.autoLogin': 'Conectare automată',
    'account.userLogin': 'Conectare utilizator',
    'account.registerTips': 'Nu aveți cont? Faceți clic aici pentru a vă înregistra',
    'account.userEmail': 'Nume utilizator/Email',
    'account.userEmailTips': 'Introduceți nume utilizator/email',
    'account.password': 'Parolă',
    'account.passwordTips': 'Introduceți parola',
    'account.submit': 'Trimite',
    'account.submitTips': 'Se trimite, vă rugăm așteptați...',
    'account.otherLoginTips': 'Sau alegeți alt mod de conectare',
    'account.userRegistration': 'Înregistrare utilizator',
    'account.userName': 'Nume utilizator',
    'account.userNameTips': 'Introduceți nume utilizator',
    'account.emailTips1': 'Introduceți adresa de email',
    'account.emailTips2': 'Format adresă email invalid',
    'account.phone': 'Număr de telefon',
    'account.phoneTips1': 'Introduceți numărul de telefon',
    'account.phoneTips2': 'Număr de telefon invalid',
    'account.phoneTips3': 'Introduceți numărul de telefon',
    'account.passwordTips1': 'Introduceți o parolă de 6-30 de caractere',
    'account.passwordTips2': 'Format parolă invalid. Parola trebuie să conțină litere, cifre, underscore, liniuțe și puncte, lungime 6-12 caractere',
    'account.passwordTips3': 'Parolele nu se potrivesc, verificați și încercați din nou!',
    'account.passwordTips4': 'Introduceți parola. Parola trebuie să conțină litere, cifre, underscore, liniuțe și puncte',
    'account.passwordTips5': 'Confirmă parola',
    'account.passwordTips6': 'Introduceți parola de confirmare',
    'account.passwordTips7': 'Parolele nu se potrivesc, verificați și încercați din nou!',
    'account.passwordTips8': 'Introduceți parola de confirmare',
    'account.passwordTips9': 'Felicitări! Înregistrare reușită!',
    'account.passwordTips10': 'Numele dvs. de utilizator este:',
    'account.emailIs': 'Emailul este:',
    'account.goToLoginPage': 's va fi redirecționat automat la pagina de conectare',
    'account.goLogin': 'Conectează-te',
    'account.goRegister': 'Înregistrează-te',
    'account.loginSuccess': 'Conectare reușită',
    'account.email': 'Email',
    'account.sologn': 'Soluții energetice personalizate cu grijă',
    'account.pleaseAgree': 'Am citit și sunt de acord cu',
    'userAgreement.privacyPolicy': 'Politica de confidențialitate',

    "account.code": "Cod de verificare",
    "account.codeTips": "Introduceți codul de verificare",
    "account.codeTips2": "Cod de verificare invalid",

    "account.inviteCodeTips": "Vă rugăm introduceți codul de invitație",
    "account.inviteCodeHint": "Vă rugăm contactați instalatorul sau personalul de operare și întreținere pentru a obține codul de invitație",
    "account.modifyPasswordByAccount": "Modifică parola prin cont",
    "account.modifyPasswordByEmail": "Modifică parola prin email",
    "account.getPasswordByAccount": "Recuperează parola prin cont",
    "account.getPasswordByEmail": "Recuperează parola prin email",

    "account.sendEmailTips": "Codul de verificare a fost trimis pe email, verificați căsuța poștală",
    "account.name": "Nume cont",
    "account.newPassword": "Parolă nouă",
    "account.confirmNewPassword": "Confirmă parola nouă",
    "account.nameTips": "Introduceți numele contului",
    "account.passwordModifySuccess": "Modificarea parolei a reușit",
    "account.emailCode": "Cod de verificare email",
    "account.emailCodeTips": "Introduceți codul de verificare email",
    "account.emailCodeTips2": "Cod de verificare email invalid",
    "account.emailModifySuccess": "Modificarea parolei a reușit",
    "account.passworTips1": "Parola dvs. a fost resetată cu succes!",
    "account.passwordTips11": "Introduceți parola de confirmare",
    "account.passwordTips12": "Introduceți parola nouă",
    "account.nickname": "Poreclă utilizator",
    "account.modifyNickname": "Modifică porecla utilizator",
    "account.modifyNicknameSuccess": "Porecla utilizator a fost modificată cu succes!",
    "account.nicknameTips": "Introduceți porecla utilizator",
    'account.nicknameError': 'Modificarea poreclei utilizator a eșuat!',

    "account.login": 'Conectează-te',
    'account.quickRegister': 'Înregistrare rapidă',
    'account.sendCode': 'Trimite cod',
    'account.sendTips': 's se poate retrimite',
    "account.sendEmailIng": 'Se trimite email, vă rugăm așteptați...',
    'account.emailNotEmpty': 'Adresa de email nu poate fi goală',
    'account.registerAccount': 'Înregistrează cont',
    'account.registerWelcome': 'Bine ați venit la SusprSafe',
    'account.usernameLimit': 'Numele de utilizator trebuie să înceapă cu o literă și poate conține doar litere, cifre și underscore, lungime 5-15 caractere',

    'copyright.desc2': 'Informații de înregistrare site: Yue ICP-bei 2021169764',

    'editUserInfo.editUserInformation': 'Editează informațiile utilizator',
    'editUserInfo.modifyUsername': 'Modifică numele de utilizator',
    'editUserInfo.changePictures': 'Schimbă imaginea de profil',
    'editUserInfo.savePicturesSuccess': 'Imaginea de profil a fost salvată cu succes',
    'editUserInfo.saveError': 'Salvarea a eșuat',
    'editUserInfo.pictureLimit':'Imaginea trebuie să fie mai mică de 2MB',
    'editUserInfo.uploadPicture':'Încarcă imagine de profil',
    'editUserInfo.picturePreview': 'Previzualizare',
    
    'editUserInfo.bindPhoneNumber': 'Leagă număr de telefon',
    'editUserInfo.bindEmail': 'Leagă email',
    'editUserInfo.changePassword': 'Schimbă parola',

    'editUserInfo.notificationSettings': 'Setări notificări',
    'editUserInfo.editAccount': 'Editează informațiile contului',
    'editUserInfo.waitBingting': 'Se leagă, vă rugăm așteptați...',
    'editUserInfo.collapse': 'Restrânge',
    'editUserInfo.modifyBinding': 'Modifică legătura',
    
    'editUserInfo.emailAddress': 'Adresă email',
    'editUserInfo.tips1': 'Legarea emailului a reușit',
    'editUserInfo.tips2': 'Salvarea a eșuat',
    'editUserInfo.tips3': 'Se trimite cod de verificare email, vă rugăm așteptați...',
    'editUserInfo.tips4': 'Codul de verificare a fost trimis pe email xxxx, verificați',
    'editUserInfo.tips5': 'Trimiterea codului de verificare a eșuat!',
    'editUserInfo.tips6': 'Număr de telefon deja legat',
    'editUserInfo.tips7': 'Email deja legat',
    'editUserInfo.emailTips1': 'Introduceți adresa de email',
    'editUserInfo.emailTips2': 'Format adresă email invalid',
    'editUserInfo.emailTips3': 'xxxxs se poate retrimite',
    'editUserInfo.emailTips4': 'Trimite cod',
    'editUserInfo.emailTips5': 'Codul de verificare email nu poate fi gol',
    'editUserInfo.emailTips6': 'Cod de verificare email invalid',
    'editUserInfo.emailCode': 'Cod de verificare email',
    'editUserInfo.save': 'Salvează',

    'editUserInfo.phoneTips1': 'Legarea numărului de telefon a reușit',
    'editUserInfo.phoneTips2': 'Se trimite cod de verificare SMS, vă rugăm așteptați...',
    'editUserInfo.phoneTips3': 'Codul de verificare SMS a fost trimis la telefon xxxx, verificați',
    'editUserInfo.phoneTips4': 'Trimiterea codului de verificare SMS a eșuat!',
    'editUserInfo.phoneTips5': 'Introduceți numărul de telefon',
    'editUserInfo.phoneTips6': 'Format număr de telefon invalid',
    'editUserInfo.phoneTips7': 'Trimite cod de verificare SMS',
    'editUserInfo.phoneTips8': 'Cod de verificare SMS',
    'editUserInfo.phoneTips9': 'Codul de verificare telefon nu poate fi gol',
    'editUserInfo.phoneTips10': 'Cod de verificare telefon invalid',
    'editUserInfo.phone': 'Număr de telefon',


    'editUserInfo.noticeTips1': 'Obținerea setărilor de notificare a eșuat!',
    'editUserInfo.noticeTips2': 'Setările de notificare au fost salvate cu succes!',
    'editUserInfo.noticeTips3': 'Notificare baterie descărcată',
    'editUserInfo.noticeTips4': 'Notificare finalizare încărcare',
    'editUserInfo.errorNotification': 'Notificare eroare',
    'editUserInfo.updateNotification': 'Notificare actualizare',
    'editUserInfo.monthlyStatisticsNotification': 'Notificare statistici lunare',
    'editUserInfo.notificationMethod': 'Metodă de primire',

    'editUserInfo.userNameTips1': 'Numele de utilizator a fost salvat cu succes',
    'editUserInfo.userNameTips2': 'Salvarea numelui de utilizator a eșuat',
    'editUserInfo.userNameTips3': 'Introduceți numele de utilizator',
    'editUserInfo.userNameTips4': 'Format nume utilizator invalid. Trebuie să conțină cifre, underscore și litere',
    'editUserInfo.userNameTips5': 'Introduceți numele de utilizator',
    'editUserInfo.userNameTips6': 'Se salvează, vă rugăm așteptați...',
    'editUserInfo.userName': 'Nume utilizator',

    'editUserInfo.avatorTips': 'Faceți clic pentru a schimba imaginea de profil',
    'editUserInfo.verifyCodeTips1': 'Introduceți codul de verificare primit:',
    'editUserInfo.verifyCodeTips2': 'Pentru securitatea contului dvs., faceți clic pe buton pentru a trimite cod de verificare la numărul de telefon original:',
    'editUserInfo.verifyCodeTips3': 'Trimite cod',
    'editUserInfo.verifyCodeTips4': 'Telefonul original a fost verificat, introduceți noul număr de telefon de legat',
    'editUserInfo.verifyCodeTips5': 'Pentru securitatea contului dvs., faceți clic pe buton pentru a trimite cod de verificare la emailul original:',
    'editUserInfo.verifyCodeTips6': 'Emailul original a fost verificat, introduceți noul email',
    'editUserInfo.verifyCodeTips7': 'Parolă veche',
    'editUserInfo.verifyCodeTips8': 'Vă rugăm să legați mai întâi emailul!',
    'editUserInfo.verifyCodeTips9': 'Codul de verificare a fost trimis pe email, verificați căsuța poștală',
    "editUserInfo.verifyCodeTips10": ', va fi redirecționat automat la pagina de conectare',

    "hems.notice.title": "Titlu notificare", 
   "hems.notice.content": "Conținut notificare", 
   "hems.notice.operate": "Operație",
   "hems.notice.noRead": "Necitit",
   "hems.notice.read": "Citit",
   "hems.notice.warning": "Avertisment",
   "hems.notice.error": "Eroare",
   "hems.notice.success": "Statistici și decontare",
   "hems.notice.sys": "Informații sistem",
   "hems.notice.operateSuccess": "Operație reușită",
   "hems.notice.operateTips": "Selectați elementele pentru operație",

    // Pagina principală
   "hems.home.selfuseRate": "Rata autoconsumului",
   "hems.home.percent": "Procent",
   "hems.home.todayData": "Datele de astăzi",
   "hems.home.todayPowerGeneration": "Generarea de energie de astăzi",
   "hems.home.salesIncome": "Venit din vânzarea energiei",
   "hems.home.saved": "V-a economisit",
   "hems.home.reduce": "Amprentă de carbon redusă",
   "hems.home.tips1": "Nu există date, nu ați legat încă xxxx",
   "hems.home.criticalLoad": "Sarcină critică",
   "hems.home.keyVoltage": "Tensiune critică",
   "hems.home.householdLoad": "Sarcină casnică",
   "hems.home.householdVoltage": "Tensiune casnică",
   "hems.home.generalLoad": "Sarcină generală",
   "hems.home.generalVoltage": "Tensiune generală",
   "hems.home.batteryHealth": "Sănătatea bateriei",
   "hems.home.averageTemp": "Temperatură medie",
   "hems.home.gridLoad": "Încărcare rețea",
   "hems.home.toggeleDataSource": "Datele afișate au fost schimbate în:",
   "hems.home.toggleTips": "Sigur doriți să schimbați?",
   "hems.home.modeSending": 'Comanda modului se trimite, vă rugăm așteptați...',
   "hems.home.modeSuccess": "Comanda de schimbare a modului a fost trimisă cu succes!",
   "hems.home.isOnline": "Este online",
   "hems.home.useStatus": "Stare utilizare",
   "hems.home.workModeText": 'Mod de lucru curent:',
   "hems.home.toggleDataSourceText": 'Datele afișate au fost schimbate în:',
   "hems.ev.charge.status": "Stare încărcare",
   "hems.ev.charge.time": "Durată încărcare",
   "hems.ev.charge.count": "Cantitate încărcare în timp real",
   "hems.ev.charge.status.empty":"Liber",
   "hems.ev.charge.status.ing":"Se încarcă cu cablu conectat",
   "hems.ev.charge.status.null":"Cablu conectat, nu se încarcă",
   "hems.ev.charge.status.error":"Defect",
   "hems.hour":"oră",
   "hems.minue":"minut",
   "hems.ev.chagre.number": "Număr stație de încărcare",

   // Ghid utilizator
   "hems.userGuide.selfUse": "Autoconsum",
   "hems.userGuide.selfUseTips": "Prioritate utilizare energie solară, completare din rețea la nevoie",
   "hems.userGuide.economyMode": "Mod economic",
   "hems.userGuide.economyModeTips": "Optimizează consumul energetic pe baza prețurilor energiei",
   "hems.userGuide.emergencyMode": "Mod de urgență",
   "hems.userGuide.emergencyModeTips": "Asigură alimentarea sarcinii critice în primul rând",

   // Pagina diagrame
   "hems.history.energyStatistics": "Statistici energie",
   "hems.history.revenueStatistics": "Statistici venituri",
   "hems.history.greenStatistics": "Contribuție verde",
   "hems.history.revenueTitle": "Venit total din vânzarea energiei",
   "hems.history.savingsTitle": "Economii totale",
   "hems.history.carbonTitle": "Reducere totală emisii carbon",
   "hems.history.day": "Zi",
   "hems.history.month": "Lună",
   "hems.history.year": "An",
   "hems.history.beforeDay": "Ieri",
   "hems.history.afterDay": "Mâine",
   "hems.history.beforeMonth": "Lună trecută",
   "hems.history.afterMonth": "Lună viitoare",
   "hems.history.beforeYear": "An trecut",
   "hems.history.afterYear": "An viitor",
   "hems.history.totalUse": 'Utilizare totală',
   "hems.history.fullScreen": 'Ecran complet',
   "hems.history.timeSelect": "Selectare dată",
   "sync.tips1": "Comanda de sincronizare date a fost trimisă cu succes!",
   "sync.tips2":"Sincronizarea datelor este în curs, datorită volumului mare de date, poate dura până la o jumătate de oră, vă rugăm reveniți mai târziu~",
   "sync.tips3": "Sincronizarea datelor dispozitivului poate întârzia. Dacă datele par inexacte, faceți clic:",
   "sync.tips4": "Sincronizează date",

   "charge.info": "Informații stație de încărcare",
    "news.loading": 'Se încarcă...',
    "news.noMore": 'Nu mai sunt',
    "hems.pv.power": 'Alimentare energie solară',

  // Specific UEH
  "ueh.sellPower": "Cantitate energie vândută",
  
  "menu.home": "Pagina principală",
  "menu.history": "Istoric",
  "menu.device": "Dispozitive",
  "menu.settings": "Setări",
  "menu.messageCenter": "Notificări",
  "menu.help": "Ajutor și suport",
  "menu.mine": "Contul meu",


  "mine.userSetting": "Setări utilizator",
  "mine.terminalSetting": "Setări de bază terminal",
  "mine.uploadCloud": "Backup date în cloud",
  "mine.changeVersion": "Verifică actualizări",
  "mine.language": "Schimbă limba",
  "mine.about": "Despre",
  "mine.feedback": "Feedback și sugestii",
  "mine.logout": "Deconectare",
  "mine.logoutAccount": "Șterge cont",

  "mine.logoutAccountTips": "Șterge contul cu numele []",
  "mine.logoutAccountTips1": "Șterge contul legat []",
  "mine.logoutAccountCare": "Aspecte importante la ștergerea contului:",
  "mine.logoutAccountCare1": "1. Contul este într-o stare sigură",
  "mine.logoutAccountCare1-1": "Contul este utilizat în mod normal, nu există risc de furt, încălcare, dezactivare etc.",
  "mine.logoutAccountCare2": "2. Autorizațiile/legăturile contului au fost anulate",
  "mine.logoutAccountCare2-1": "Contul a încetat autorizațiile cu serviciile terțe.",
  "mine.logoutAccountCare3": "3. Contul nu poate fi recuperat după ștergere, toate datele sunt șterse",
  "mine.logoutAccountCare3-1": "După ștergerea contului, toate datele și numerele de telefon/adresele de email legate sunt eliminate permanent.",
  "mine.confirmLogout": "Confirmă ștergerea",
  "mine.logoutSuccess": "Contul a fost șters!",

  "mine.feedbackIssues": "Raportează probleme",
  "mine.feedQuantity": "Cantitate",
  "mine.feedAmount": "Maximum 9 imagini, maximum 1MB/imagine",

  "mine.notice.fail": "Obținerea setărilor de notificare a eșuat!",
  "mine.notice.saveSuccess": "Setările de notificare au fost salvate cu succes!",
  "mine.notice.saveFail": "Salvarea a eșuat!",
  "mine.notice.title": "Setări notificări",
  "mine.notice.batteryLow": "Notificare baterie descărcată",
  "mine.notice.chargingFinish": "Notificare finalizare încărcare",
  "mine.notice.error": "Notificare eroare",
  "mine.notice.update": "Notificare actualizare",
  "mine.notice.monthly": "Notificare statistici lunare",
  "mine.notice.receiveType": "Metodă de primire",

  "mine.language.welcome": "Bine ați venit la SusprSafe",
  "mine.language.desc1": "Vă rugăm selectați versiunea lingvistică în funcție de regiunea dvs.",
  "mine.language.desc2": "Puteți schimba acest lucru din setările aplicației în orice moment",

  "mine.userInfo.avatar":"Avatar",
  "mine.userInfo.nickname":"Poreclă",
  "mine.userInfo.password":"Parolă",
  "mine.userInfo.changePassword":"Schimbă parola",
  "mine.userInfo.setPassword":"Setează parola",
  "mine.userInfo.phoneNumber":"Număr de telefon",
  "mine.userInfo.bindPhone":"Leagă număr de telefon",
  "mine.userInfo.bindEmail":"Leagă email",
  "mine.loginExpired":"Conectarea a expirat, reconectați-vă",
  "mine.userInfo.title":"Informații utilizator",
  "mine.userInfo.bind":"Leagă",
  "mine.userInfo.modify": "Modifică",
  "mine.userInfo.modifyNickname":"Modifică porecla",
  "mine.userInfo.userNickname":"Poreclă utilizator",
  "mine.userInfo.selectPic":"Selectați imaginea de încărcat",
  "mine.userInfo.saveSuccess":"Salvat cu succes",
  "mine.userInfo.uploadFail":"Încărcarea a eșuat",
  "mine.userInfo.avatarSaveSuccess":"Avatar salvat cu succes",
  "mine.userInfo.nameTips1":"Porecla nu poate fi goală",
  "mine.userInfo.nameTips2":"Introduceți porecla",

  "common.pleaseSelect": "Vă rugăm selectați",
  "question.commonQuestions": "Întrebări frecvente",
  "account.toggleLanguage": 'Schimbă limba',
  "account.localConnection": "Conexiune locală",
  "account.selectLanguage": 'Selectați limba',
  "account.sendEmailToast": "Codul de verificare a fost trimis pe email xxx, verificați căsuța poștală",
  "account.emailError": "Format email invalid",
  "account.sendEmailFail": "Trimiterea a eșuat, încercați din nou",

  "common.submitting": "Se trimite, vă rugăm așteptați...",

  "device.page.noData": "Nu există date, această pagină necesită aplicația pentru previzualizare"
 
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};